import { render, staticRenderFns } from "./admin-partial-sponsoring.vue?vue&type=template&id=a87ecf6c&"
import script from "./admin-partial-sponsoring.ts?vue&type=script&lang=ts&"
export * from "./admin-partial-sponsoring.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports